import React from 'react'
import { Outlet } from 'react-router-dom'

const StaticContentOutlet = () => {
  return (
    <>
     <Outlet/>
    </>
  )
}

export default StaticContentOutlet
